import { render, staticRenderFns } from "./course-chunk.vue?vue&type=template&id=38780e12&scoped=true&"
import script from "./course-chunk.vue?vue&type=script&lang=js&"
export * from "./course-chunk.vue?vue&type=script&lang=js&"
import style0 from "./course-chunk.vue?vue&type=style&index=0&id=38780e12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38780e12",
  null
  
)

export default component.exports